module.exports = __webpack_public_path__ + "img/add-circle.5dae5322.svg";